<template>
  <AppGenericInput
    v-model="givenValue"
    component-name="v-select"
    :items="eventCategories"
    v-bind="{ ...$attrs, multiple, dataTest }"
    :inherit-listeners="$listeners"
    :label="label"
    hide-no-data
    :menu-props="menuProps"
    item-value="id"
    item-text="name"
  />
</template>
<script>
import { ref, computed } from "vue";
import { useEventCategoryHelper } from "@composables/masterdata/eventCategories";
import AppGenericInput from "./AppGenericInput.vue";

export default {
  name: "AppSelectEventCategory",
  components: { AppGenericInput },
  props: {
    value: {
      type: [String, Array],
      default: null
    },
    menuProps: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: function() {
        return "Event category";
      }
    },
    dataTest: {
      type: String,
      default: "eventCategory"
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    const {
      masterEventCategories,
      masterEventCategoriesActive
    } = useEventCategoryHelper();

    const selectedInactives = ref([]);

    const givenValue = computed({
      get() {
        return props.value;
      },
      set(v) {
        ctx.emit("input", v);
      }
    });

    const eventCategories = computed(() => {
      return [...selectedInactives.value, ...masterEventCategoriesActive.value];
    });

    if (Array.isArray(props.value)) {
      const missing = props.value
        .filter(valueId =>
          masterEventCategoriesActive.value.find(y => y.id == valueId)
            ? false
            : true
        )
        .map(valueId => masterEventCategories.value.find(y => y.id == valueId))
        .filter(Boolean);
      if (missing.length) {
        selectedInactives.value = missing;
      }
    } else if (
      props.value &&
      !masterEventCategoriesActive.value.some(x => x.id == props.value)
    ) {
      selectedInactives.value = [
        masterEventCategories.value.find(y => y.id == props.value)
      ];
    }

    return {
      selectedInactives,
      givenValue,
      eventCategories
    };
  }
};
</script>
